var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Alert, Box, Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageLimit, theme } from "@sequentech/ui-essentials";
import { stringToHtml, translate, translateFromPresentation, ESupportMaterialsPolicy, getEffectiveSupportMaterialsPolicy, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectFirstBallotStyle } from "../store/ballotStyles/ballotStylesSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { SupportMaterial } from "../components/SupportMaterial/SupportMaterial";
import { getSupportMaterialsList, } from "../store/supportMaterials/supportMaterialsSlice";
import { selectElectionEventById } from "../store/electionEvents/electionEventsSlice";
import Stepper from "../components/Stepper";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { useMutation, useQuery } from "@apollo/client/react";
import { GET_DOCUMENT } from "../queries/GetDocument";
import { setDocument } from "../store/documents/documentsSlice";
import { ACKNOWLEDGE_SUPPORT_MATERIALS } from "../queries/AcknowledgeSupportMaterials";
import { GET_SUPPORT_MATERIALS_ACKNOWLEDGMENT } from "../queries/GetSupportMaterialsAcknowledgment";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"])));
var ElectionContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"])));
var ElectionWrapper = function (_a) {
    var material = _a.material, onViewed = _a.onViewed;
    var tenantId = useParams().tenantId;
    var i18n = useTranslation().i18n;
    return (_jsx(SupportMaterial, { title: translate(material.data, "title", i18n.language) || "", subtitle: translate(material.data, "subtitle", i18n.language) || "", kind: material.kind || "", tenantId: tenantId || "", documentId: material.document_id || "", onViewed: onViewed }));
};
var SupportMaterialsScreen = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g = useTranslation(), t = _g.t, i18n = _g.i18n;
    var navigate = useNavigate();
    var location = useLocation();
    var _h = useParams(), eventId = _h.eventId, tenantId = _h.tenantId;
    var materials = useAppSelector(getSupportMaterialsList());
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var ballotStyle = useAppSelector(selectFirstBallotStyle);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var dispatch = useAppDispatch();
    var _j = useState([]), materialsList = _j[0], setMaterialsList = _j[1];
    var documents = useQuery(GET_DOCUMENT, {
        variables: {
            ids: (_a = materialsList === null || materialsList === void 0 ? void 0 : materialsList.map(function (material) { var _a; return (_a = material.document_id) !== null && _a !== void 0 ? _a : ""; })) !== null && _a !== void 0 ? _a : [],
            electionEventId: eventId,
            tenantId: tenantId || "",
        },
        skip: globalSettings.DISABLE_AUTH,
    }).data;
    useEffect(function () {
        if (globalSettings.DISABLE_AUTH || !(documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document)) {
            return;
        }
        for (var _i = 0, _a = documents.sequent_backend_document; _i < _a.length; _i++) {
            var document = _a[_i];
            dispatch(setDocument(document));
        }
    }, [documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document, globalSettings.DISABLE_AUTH]);
    useEffect(function () {
        var materialsList = [];
        for (var material in materials) {
            materialsList.push(materials[material]);
        }
        setMaterialsList(materialsList);
    }, [materials]);
    var _k = useState(), materialsTitles = _k[0], setMaterialsTitles = _k[1];
    var defaultLanguageCode = (_c = (_b = materialsTitles === null || materialsTitles === void 0 ? void 0 : materialsTitles.presentation) === null || _b === void 0 ? void 0 : _b.language_conf) === null || _c === void 0 ? void 0 : _c.default_language_code;
    useEffect(function () {
        if (electionEvent) {
            setMaterialsTitles(electionEvent);
        }
    }, [electionEvent]);
    // Sourced from the published ballot style snapshot, not the live election
    // event, so a policy change only takes effect after the next publication.
    var materialsPolicy = getEffectiveSupportMaterialsPolicy((_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _d === void 0 ? void 0 : _d.materials);
    var isMandatory = materialsPolicy === ESupportMaterialsPolicy.MANDATORY_FOR_VOTING;
    var _l = useState(new Set()), viewedIds = _l[0], setViewedIds = _l[1];
    var _m = useState(false), acknowledgeChecked = _m[0], setAcknowledgeChecked = _m[1];
    var _o = useState(), acknowledgeError = _o[0], setAcknowledgeError = _o[1];
    var _p = useState(false), acknowledging = _p[0], setAcknowledging = _p[1];
    var acknowledgeSupportMaterials = useMutation(ACKNOWLEDGE_SUPPORT_MATERIALS, {
        update: function (cache, _a) {
            var data = _a.data;
            if (!eventId || !(data === null || data === void 0 ? void 0 : data.acknowledge_support_materials)) {
                return;
            }
            cache.writeQuery({
                query: GET_SUPPORT_MATERIALS_ACKNOWLEDGMENT,
                variables: { electionEventId: eventId },
                data: {
                    get_support_materials_acknowledgment: {
                        __typename: "GetSupportMaterialsAcknowledgmentOutput",
                        document_ids: data.acknowledge_support_materials.document_ids,
                    },
                },
            });
        },
    })[0];
    var allMaterialsViewed = useMemo(function () { return (materialsList !== null && materialsList !== void 0 ? materialsList : []).every(function (material) { return viewedIds.has(material.id); }); }, [materialsList, viewedIds]);
    var handleNavigateMaterials = function () {
        navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
    };
    var handleContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var documentIds, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!eventId) {
                        return [2 /*return*/];
                    }
                    setAcknowledging(true);
                    setAcknowledgeError(undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    documentIds = (materialsList !== null && materialsList !== void 0 ? materialsList : [])
                        .map(function (material) { return material.document_id; })
                        .filter(function (documentId) { return Boolean(documentId); });
                    return [4 /*yield*/, acknowledgeSupportMaterials({
                            variables: { electionEventId: eventId, documentIds: documentIds },
                        })];
                case 2:
                    result = _a.sent();
                    if (result.error) {
                        setAcknowledgeError(t("materials.mandatory.error"));
                        return [2 /*return*/];
                    }
                    handleNavigateMaterials();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    setAcknowledgeError(t("materials.mandatory.error"));
                    return [3 /*break*/, 5];
                case 4:
                    setAcknowledging(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(PageLimit, { className: "support-materials-screen screen", maxWidth: "lg", children: [_jsx(Box, { className: "stepper-box", marginTop: "48px", children: _jsx(Stepper, { selected: 0 }) }), _jsxs(Box, { className: "support-materials-header", sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "100px",
                }, children: [_jsxs(Box, { className: "support-materials-heading", children: [_jsx(StyledTitle, { className: "screen-title", variant: "h1", children: _jsx(Box, { className: "screen-title-text", children: materialsTitles &&
                                        ((_e = translateFromPresentation(materialsTitles, "materialsTitle", i18n.language, { defaultLanguageCode: defaultLanguageCode })) !== null && _e !== void 0 ? _e : "-") }) }), _jsx(Typography, { className: "screen-description", variant: "body1", component: "div", sx: { color: theme.palette.customGrey.contrastText }, children: stringToHtml(materialsTitles
                                    ? ((_f = translateFromPresentation(materialsTitles, "materialsSubtitle", i18n.language, { defaultLanguageCode: defaultLanguageCode })) !== null && _f !== void 0 ? _f : "-")
                                    : "") })] }), _jsx(Button, { className: "back-button", startIcon: _jsx(ChevronLeftIcon, { className: "back-button-icon" }), onClick: handleNavigateMaterials, children: t("materials.common.back") })] }), _jsx(ElectionContainer, { className: "support-materials-list", children: materialsList === null || materialsList === void 0 ? void 0 : materialsList.map(function (material) { return (_jsx(ElectionWrapper, { material: material, onViewed: function () { return setViewedIds(function (prev) { return new Set(prev).add(material.id); }); } }, material.id)); }) }), isMandatory ? (_jsxs(Box, { className: "materials-acknowledgement", sx: { marginTop: "20px" }, children: [acknowledgeError ? (_jsx(Alert, { className: "materials-acknowledgement-error", severity: "error", sx: { marginBottom: "16px" }, children: acknowledgeError })) : null, _jsx(FormControlLabel, { className: "materials-acknowledgement-label", control: _jsx(Checkbox, { className: "materials-acknowledgement-checkbox", checked: acknowledgeChecked, disabled: !allMaterialsViewed, onChange: function (event) { return setAcknowledgeChecked(event.target.checked); }, inputProps: {
                                "aria-label": t("materials.mandatory.checkboxLabel"),
                            } }), label: t("materials.mandatory.checkboxLabel") }), _jsx(Box, { className: "materials-actions", sx: { marginTop: "16px" }, children: _jsx(Button, { className: "materials-continue-button", disabled: !acknowledgeChecked || acknowledging, onClick: handleContinue, children: t("materials.mandatory.continueButton") }) })] })) : null] }));
};
export default SupportMaterialsScreen;
var templateObject_1, templateObject_2;
